export default __webpack_public_path__ + "static/media/card5.99c1a9ee.png";